<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="进入成员系统"
        width="550px"
        append-to-body>
        <el-form ref="form" :model="formItem" :rules="rules" label-width="0px" class="pr20">
            <el-form-item label="" prop="account">
                <ESelect
                    ref="searchInput"
                    v-model="formItem.account"
                    filterable
                    remote
                    clearable
                    :remote-method="getUserList"
                    class="full-w"
                    placeholder="输入成员名称关键字搜索成员">
                    <el-option
                        v-for="item in userList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </ESelect>
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">进入系统</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/home.js';

    export default {
        name: "ToSubModal",
        data() {
            return {
                dialogVisible: false,
                dataLoading:false,
                userList:[],
                formItem:{
                    account:'',
                },
                rules:{
                    account:[
                        { required: true, message: '请选择成员', trigger: 'change' }
                    ]
                }
            }
        },
        methods: {
            handleClose() {
                this.resetForm();
                this.dialogVisible = false;
            },
            resetForm(){
                this.account = '';
                this.$refs['form'].resetFields();
            },
            showModal() {
                this.dialogVisible = true;
                this.$nextTick(()=>{
                    this.getUserList();
                    this.$refs.searchInput.focus();
                })
            },
            getUserList(query){
                if (query !== '') {
                    this.dataLoading = true;
                    API.getSubUserList({
                        search: query,
                    }).then(res => {
                        this.userList = res.data || [];
                        this.dataLoading = false;
                    }, (err) => {
                        console.log('getUserList error', err);
                        this.userList = [];
                        this.dataLoading = false;
                    });
                } else {
                    this.userList = [];
                }
            },
            handleSubmit(){
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        let subUid = this.formItem.account;
                        let routeData = this.$router.resolve({
                            name: "home",
                            query: {
                                sub_uid:subUid,
                                log:1,
                            }
                        });
                        window.open(routeData.href, 'SUB_'+subUid, '_blank');

                        this.handleClose();
                    } else {
                        return false;
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped >
    .action-btn{
        width: 120px;
    }
</style>
